
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { StateLoader } from './redux/StateLoader';
import { IAuthentication, UserRole } from './interfaces/authentication';

const ProtectedRoute = ({ render, requiredLicence, ...rest }) => {
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const hasLicence =
        userInfo.role === UserRole.AltisAdmin
            ? true
            : requiredLicence
                ? userInfo.licencePackage?.[requiredLicence]
                : true;
    return (
        <Route
            {...rest}
            render={props =>
                hasLicence ? render(props) : <Redirect to="/admin/dashboard" />
            }
        />
    );
};
export default ProtectedRoute;